<template>
  <div class="form">
    <div class="form__block">
      <p>{{ t('fields.firstName') }}</p>
      <ui-input
          :type="'text'"
          :placeholder="t('fields.firstName')"
          :rules="[required]"
          v-model="firstName"
      />
    </div>
    <div class="form__block">
      <p>{{ t('fields.lastName') }}</p>
      <ui-input
          :type="'text'"
          :placeholder="t('fields.lastName')"
          :rules="[required]"
          v-model="lastName"
      />
    </div>
    <div class="form__block">
      <p>{{ t('fields.email') }}</p>
      <ui-input
          :type="'email'"
          :placeholder="t('fields.email')"
          :rules="[isEmail]"
          v-model="email"
      />
    </div>
    <div class="form__block">
      <p>{{ t('fields.newPassword') }}</p>
      <ui-input
          :type="'password'"
          :placeholder="t('fields.newPassword')"
          :rules="[isPasswordValid]"
          v-model="password"
      />
    </div>
    <div class="form__block">
      <p>{{ t('fields.confirmNewPassword') }}</p>
    <ui-input
        :type="'password'"
        :placeholder="t('fields.confirmNewPassword')"
        :rules="[compareStrings]"
        v-model="confirmPassword"
    />
    </div>
    <ui-button
        class="form__button"
        @click="updateUser"
        :isLoading="isLoading"
    >
      {{ t('buttons.save') }}
    </ui-button>
  </div>
</template>

<script setup>
import {isEmail, isPasswordValid, required} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useAuthStore} from "@/stores/auth.js";
import {ElNotification} from "element-plus";
import {Auth} from "@/core/api/auth.js";
import {useRouter} from "vue-router";
import UiButton from "@/components/ui/ui-button.vue";

const {t} = useI18n()
const authStore = useAuthStore()
const router = useRouter()

const accessToken = computed(() => authStore.accessToken)
const user = computed(() => authStore.user)
const userUuid = computed(() => {
  return authStore.user ? authStore.user.uuid : ''
})
const userEmail = computed(() => {
  return authStore.user ? authStore.user.email : ''
})

const firstName = ref(user.value ? user.value.firstName : '')
const lastName = ref(user.value ? user.value.lastName : '')
const email = ref(user.value ? user.value.email : '')
const password = ref('')
const confirmPassword = ref('')

const isLoading = ref(false)

const compareStrings = (v) => {
  if (v === password.value) return true
  return t('errors.compare')
}

const updateUser = async () => {
  isLoading.value = true

  const res = await Auth.updateUser(
      `uuid: "${userUuid.value}"` +
      (email.value ? `, email: "${email.value}"` : "") +
      (firstName.value ? `, firstName: "${firstName.value}"` : "") +
      (lastName.value ? `, lastName: "${lastName.value}"` : "") +
      (password.value ? `, password: "${password.value}"` : "") +
      (confirmPassword.value ? `, confirmPassword: "${confirmPassword.value}"` : ""),
      accessToken.value
  )

  if (!res.errors) {
    if(userEmail.value !== email.value) {
      await logout()
    } else {
      authStore.setUser({
        user: res.data.updateUser.user,
        accessToken: accessToken.value
      })

      ElNotification({
        message: t('popup.updateData'),
        type: 'success'
      })
    }
  } else {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }

  isLoading.value = false
}

const logout = async () => {
  authStore.setUser({
    user: null,
    accessToken: null
  })

  localStorage.removeItem('awe-refresh')

  await router.push({
    name: 'home',
    params: {
      locale: localStorage.getItem('awe-user-locale') || 'en-gb'
    }
  })
}
</script>

<style lang="scss" scoped>
.form {
  width: 50%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__button {
    margin-top: 10px;
    width: fit-content;
    padding-inline: 20px;
  }

  &__block {
    display: flex;
    flex-direction: column;
    gap: 5px;

    & p {
      color: $white;
      font-size: 20px;
    }
  }
}

@media (max-width: 1300px) {
  .form {
    width: 100%;
  }
}
</style>